module.exports = __webpack_public_path__ + "img/numberplateBadgeSwitzerland.1698e337.svg";